import { PlatFormTypes, UserInfoType } from './../../types/state/metaTypes'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { deleteCookie } from '../../helpers/Cookie'
import { WindowResizeType } from '../../types/hooks'
import { DeviceTypes, MetaType, ViewTypes } from '../../types/state'

const initialState: MetaType = {
	isLogin: false,
	deviceType: DeviceTypes.MOBILE,
	platform: PlatFormTypes.MWEB,
	view: ViewTypes.LANDING,
	isLoading: false,
	userInfoStep: UserInfoType.REGINAL_LANGUAGE_PROFICIENCY,
	isError: false,
	votingClose: true,
	errorMessage: '',
	nextRouteParams: '',
}

interface ErrorObjType {
	message: string | ''
	status: boolean
}

export const metaSlice = createSlice({
	name: 'meta',
	initialState,
	reducers: {
		updateDeviceType: (state, action: PayloadAction<WindowResizeType>) => {
			if (
				action.payload.width === undefined ||
				action.payload.width <= 481
			) {
				state.deviceType = DeviceTypes.MOBILE
			} else if (action.payload.width > 481 && action.payload.width <= 961) {
				state.deviceType = DeviceTypes.TAB
			} else {
				state.deviceType = DeviceTypes.DESKTOP
			}
		},
		updatePlatformType: (state, action: PayloadAction<PlatFormTypes>) => {
			state.platform = action.payload
		},
		updateView: (state, action: PayloadAction<ViewTypes>) => {
			state.view = action.payload
		},
		updateLogin: (state, action: PayloadAction<boolean>) => {
			state.isLogin = action.payload
		},
		setLoadingStatus: (state, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload
		},
		setErrorStatus: (state, action: PayloadAction<ErrorObjType>) => {
			state.isError = action.payload.status
			state.errorMessage = action.payload.message
		},
		onLogout: (state) => {
			deleteCookie('frontend')
			state.isLogin = false
			state.view = ViewTypes.LANDING
			state.userInfoStep = UserInfoType.REGINAL_LANGUAGE_PROFICIENCY
		},
		updateVotingClose: (state, action: PayloadAction<boolean>) => {
			state.votingClose = action.payload
		},
		updateStep: (state, action: PayloadAction<UserInfoType>) => {
			state.userInfoStep = action.payload
		},
		updateNextRouteParams: (state, action: PayloadAction<string>) => {
			state.nextRouteParams = action.payload
		},
	},
})

export const {
	updateView,
	updateStep,
	updateLogin,
	updateDeviceType,
	setLoadingStatus,
	setErrorStatus,
	updateVotingClose,
	onLogout,
	updatePlatformType,
	updateNextRouteParams,
} = metaSlice.actions

export default metaSlice.reducer
